export default __webpack_public_path__ + "static/14_21-24605649c61e581a1977aaab528f1b0b.png";